var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _path, _path2, _path3, _circle, _path4, _circle2, _path5, _circle3, _circle4, _circle5, _circle6, _circle7, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.109,
    x2: 533.786,
    xlinkHref: "#lg1",
    y1: 209.677,
    y2: 591.354
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.445,
    x2: 523.85,
    xlinkHref: "#lg1",
    y1: 276.998,
    y2: 509.403
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343168",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1464"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.449,
    x2: 245.08,
    xlinkHref: "#lg2",
    y1: 392.455,
    y2: 49.239
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.067,
    x2: 174.714,
    xlinkHref: "#lg3",
    y1: 231.37,
    y2: 311.017
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.726,
    x2: 25.996,
    xlinkHref: "#lg2",
    y1: 280.677,
    y2: 163.556
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.204,
    x2: 306.137,
    xlinkHref: "#lg3",
    y1: 390.046,
    y2: 472.978
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.588,
    x2: 488.98,
    xlinkHref: "#lg3",
    y1: 252.307,
    y2: 332.698
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.3,
    x2: 184.091,
    xlinkHref: "#lg3",
    y1: 327.928,
    y2: 359.719
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.788,
    x2: 405.579,
    xlinkHref: "#lg3",
    y1: 403.68,
    y2: 435.471
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.384,
    x2: 277.174,
    xlinkHref: "#lg3",
    y1: 284.399,
    y2: 316.19
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.761,
    x2: 136.349,
    xlinkHref: "#lg3",
    y1: 392.384,
    y2: 439.971
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.062,
    x2: 373.649,
    xlinkHref: "#lg3",
    y1: 325.179,
    y2: 372.766
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.545,
    x2: 274.545,
    xlinkHref: "#lg2",
    y1: 379.332,
    y2: 574.592
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.427,
    x2: 263.427,
    xlinkHref: "#lg2",
    y1: 280.584,
    y2: 389.02
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.129,
    x2: 459.449,
    xlinkHref: "#lg1",
    y1: 100.989,
    y2: 381.309
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.959,
    x2: 449.085,
    xlinkHref: "#lg1",
    y1: 172.167,
    y2: 294.293
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.12,
    x2: 347.575,
    xlinkHref: "#lg1",
    y1: 113.996,
    y2: 289.7
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.766,
    x2: 256.843,
    xlinkHref: "#lg3",
    y1: 119.687,
    y2: 184.299
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.334,
    x2: 251.733,
    xlinkHref: "#lg3",
    y1: 124.057,
    y2: 242.046
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.134,
    x2: 369.26,
    xlinkHref: "#lg3",
    y1: 190.298,
    y2: 220.307
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.489,
    x2: 145.366,
    xlinkHref: "#lg3",
    y1: 186.356,
    y2: 255.75
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.033,
    x2: 197.092,
    xlinkHref: "#lg2",
    y1: 205.878,
    y2: 26.335
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.154,
    x2: 192.041,
    xlinkHref: "#lg2",
    y1: 177.358,
    y2: 47.01
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.253,
    x2: 215.157,
    xlinkHref: "#lg3",
    y1: 90.576,
    y2: 170.449
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.648,
    x2: 227.644,
    xlinkHref: "#lg4",
    y1: 134.11,
    y2: 133.585
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 0 0 1 435.785 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 116.32,
    x2: 143.225,
    xlinkHref: "#lg3",
    y1: 90.576,
    y2: 170.449
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-1 0 0 1 435.785 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 114.716,
    x2: 155.712,
    xlinkHref: "#lg4",
    y1: 134.11,
    y2: 133.585
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.5,
    x2: 262.225,
    xlinkHref: "#lg3",
    y1: 121.265,
    y2: 176.852
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.068,
    x2: 91.339,
    xlinkHref: "#lg5",
    y1: 155.576,
    y2: 47.476
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.276,
    x2: 13.818,
    xlinkHref: "#lg5",
    y1: 256.411,
    y2: 119.206
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.521,
    x2: 154.509,
    xlinkHref: "#lg6",
    y1: -17.033,
    y2: 116.168
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.041,
    x2: 90.035,
    xlinkHref: "#lg6",
    y1: 132.267,
    y2: 198.868
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.885,
    x2: 453.879,
    xlinkHref: "#lg6",
    y1: 385.241,
    y2: 451.842
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.844,
    x2: 428.838,
    xlinkHref: "#lg6",
    y1: 42.774,
    y2: 109.374
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.843,
    x2: 99.837,
    xlinkHref: "#lg6",
    y1: 427.937,
    y2: 494.537
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m253.859 240.66-199.295-54.845v245.962c0 5.717 3.819 10.729 9.331 12.246l161.424 44.423c18.678 5.14 38.399 5.14 57.077 0l161.424-44.423c5.512-1.517 9.331-6.529 9.331-12.246v-112.739l-20.897-45.301 20.897-45.301v-42.622z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m253.859 240.66v251.642c9.6 0 19.199-1.285 28.539-3.855l161.424-44.423c5.512-1.517 9.331-6.529 9.331-12.246v-112.74l-15.378-45.301 15.378-45.301v-42.622z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m253.859 240.66-199.295-54.845v22.679l268.705 268.705 120.552-33.175c5.512-1.517 9.331-6.529 9.331-12.246v-112.74l-17.992-45.301 17.992-45.3v-42.622z",
    fill: "url(#SVGID_3_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.3,
    cy: 252.603,
    fill: "url(#SVGID_4_)",
    r: 47.942
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m140.217 294.146c14.356-8.283 24.025-23.779 24.025-41.543 0-26.478-21.464-47.942-47.942-47.942-17.764 0-33.261 9.67-41.543 24.025z",
    fill: "url(#SVGID_5_)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.313,
    cy: 412.155,
    fill: "url(#SVGID_6_)",
    r: 49.92
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m453.153 228.437c-6.377-2.957-13.478-4.619-20.97-4.619-27.57 0-49.92 22.35-49.92 49.92s22.35 49.919 49.92 49.919c7.492 0 14.593-1.661 20.97-4.619z",
    fill: "url(#SVGID_7_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.775,
    cy: 336.403,
    fill: "url(#SVGID_8_)",
    r: 19.136
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.263,
    cy: 412.155,
    fill: "url(#SVGID_9_)",
    r: 19.136
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.859,
    cy: 292.874,
    fill: "url(#SVGID_10_)",
    r: 19.136
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.448,
    cy: 405.07,
    fill: "url(#SVGID_11_)",
    r: 28.644
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.748,
    cy: 337.865,
    fill: "url(#SVGID_12_)",
    r: 28.644
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m253.859 461.331c23.496-4.056 41.374-24.522 41.374-49.176 0-24.655-17.878-45.121-41.374-49.176z",
    fill: "url(#SVGID_13_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m272.994 292.874c0-10.569-8.567-19.136-19.136-19.136v38.272c10.569-.001 19.136-8.568 19.136-19.136z",
    fill: "url(#SVGID_14_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m237.3 92.655-16.075 4.424-28.834 22.921-88.865 9.468-54.475 14.992c-6.01 1.654-10.174 7.119-10.174 13.352v35.813c0 6.233 4.164 11.698 10.174 13.352l188.249 51.804c10.837 2.982 22.279 2.982 33.117 0l188.249-51.805c6.01-1.654 10.174-7.119 10.174-13.352v-35.813c0-6.233-4.164-11.698-10.174-13.352l-70.451-19.388-68.132-.235-33.411-27.709-16.255-4.473c-10.838-2.982-22.279-2.982-33.117.001z",
    fill: "url(#SVGID_15_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m253.859 206.421v54.597c5.57 0 11.14-.746 16.558-2.237l66.773-18.376 121.477-33.43c6.01-1.654 10.174-7.119 10.174-13.352v-35.813c0-3.634-1.422-7-3.793-9.508z",
    fill: "url(#SVGID_16_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m253.859 206.421 79.875-21.981 15.571-20.222 52.001 1.627 63.741-17.541c-1.696-1.795-3.874-3.154-6.38-3.844l-70.451-19.388-62.49-2.578-39.054-25.366-16.255-4.473c-10.837-2.982-22.279-2.982-33.117 0l-16.075 4.424-43.763 20.886-73.935 11.504-54.476 14.991c-2.506.69-4.684 2.049-6.38 3.844l63.741 17.541 44.64-1.556 22.932 20.152z",
    fill: "url(#SVGID_17_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m401.306 165.844-25.89 15.625-41.725 2.982-214.189-59.379 51.025-14.042 16.589-4.565z",
    fill: "url(#SVGID_18_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m106.411 165.844 28.85 16.677 38.765 1.93 214.19-59.379-51.026-14.042-16.589-4.565z",
    fill: "url(#SVGID_19_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m333.733 241.357 3.457-.951 64.116-17.644v-56.918l-67.573 18.596z",
    fill: "url(#SVGID_20_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m173.984 241.357-3.456-.951-64.116-17.644v-56.917l67.572 18.596z",
    fill: "url(#SVGID_21_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m384.912 227.273-100.626-100.626c-7.56-8.204-18.392-13.347-30.427-13.347-22.85 0-41.374 18.524-41.374 41.374 0 3.26 1.689 6.053 4.577 8.383l86.581 86.581z",
    fill: "url(#SVGID_22_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m356.219 235.169c-3.842-5.922-8.232-11.576-13.175-16.279l-77.606-77.606c-27.327-27.327-67.224-37.873-104.485-27.619l-6.109 1.681c2.05 8.695 8.811 17.115 15.789 23.848l115.314 115.314z",
    fill: "url(#SVGID_23_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m251.345 153.793s-26.784-93.151-77.867-67.47 15.573 67.47 15.573 67.47 37.241 14.204 62.294 0z",
    fill: "url(#SVGID_24_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m166.779 111.979c-5.077 2.553-8.363 5.35-10.3 8.257 7.727 17.979 32.573 33.557 32.573 33.557s8.847 3.366 20.809 5.182c.027-.007.053-.013.08-.02 4.484-1.1 6.96-5.32 5.53-9.194-5.555-15.044-22.061-51.17-48.692-37.782z",
    fill: "url(#SVGID_25_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m256.372 153.793s26.784-93.151 77.867-67.47-15.573 67.47-15.573 67.47-37.241 14.204-62.294 0z",
    fill: "url(#SVGID_26_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m340.938 111.979c5.077 2.553 8.363 5.35 10.3 8.257-7.727 17.979-32.573 33.557-32.573 33.557s-8.847 3.366-20.809 5.182c-.027-.007-.053-.013-.08-.02-4.484-1.1-6.96-5.32-5.53-9.194 5.555-15.044 22.061-51.17 48.692-37.782z",
    fill: "url(#SVGID_27_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m295.232 154.674c0 22.85-82.748 22.85-82.748 0s18.524-41.374 41.374-41.374 41.374 18.524 41.374 41.374z",
    fill: "url(#SVGID_28_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m428.296 336.799-248.736-248.735c-.005 0-.01.001-.015.001-3.646.211-7.29.449-10.934.713-.002 0-.004 0-.006 0-7.183.52-14.359 1.144-21.529 1.868-.31.032-.619.064-.929.096-3.166.324-6.33.669-9.492 1.032-.454.052-.908.103-1.362.155-6.805.794-13.601 1.683-20.388 2.661-.808.117-1.615.238-2.422.357-2.557.377-5.113.768-7.668 1.172-.901.142-1.803.282-2.704.428-3.28.53-6.559 1.075-9.834 1.649 0 0 14.203 34.679 20.65 44.739l261.593 260.728z",
    fill: "url(#SVGID_29_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m357.596 424.706-280.685-281.843c-1.777-2.772-5.889-2.772-7.666 0-7.901 12.328-18.345 22.873-30.593 30.887-2.719 1.779-2.719 5.835 0 7.614l248.007 247.235c20.103 20.041 53.146 18.228 70.937-3.893z",
    fill: "url(#SVGID_30_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m189.449 81.16c-24.497 16.028-45.385 37.118-61.188 61.775-3.554 5.545-11.778 5.545-15.332 0-15.802-24.657-36.69-45.747-61.187-61.775-5.438-3.558-5.438-11.669 0-15.227 24.497-16.028 45.385-37.118 61.187-61.775 3.553-5.545 11.778-5.545 15.332 0 15.803 24.657 36.691 45.747 61.188 61.775 5.437 3.558 5.437 11.67 0 15.227z",
    fill: "url(#SVGID_31_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m107.505 181.364c-12.248 8.014-22.693 18.559-30.594 30.888-1.777 2.772-5.889 2.772-7.666 0-7.901-12.328-18.345-22.874-30.593-30.887-2.719-1.779-2.719-5.835 0-7.614 12.249-8.014 22.692-18.559 30.593-30.887 1.777-2.772 5.889-2.772 7.666 0 7.901 12.328 18.346 22.874 30.594 30.887 2.718 1.778 2.718 5.834 0 7.613z",
    fill: "url(#SVGID_32_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m471.349 434.338c-12.249 8.014-22.693 18.559-30.594 30.888-1.777 2.772-5.889 2.772-7.666 0-7.901-12.328-18.345-22.874-30.594-30.887-2.719-1.779-2.719-5.835 0-7.614 12.249-8.014 22.692-18.559 30.593-30.887 1.777-2.772 5.889-2.772 7.666 0 7.901 12.328 18.346 22.874 30.594 30.887 2.719 1.778 2.719 5.834.001 7.613z",
    fill: "url(#SVGID_33_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m446.308 91.871c-12.248 8.014-22.693 18.559-30.594 30.888-1.777 2.772-5.889 2.772-7.666 0-7.901-12.328-18.345-22.874-30.593-30.887-2.719-1.779-2.719-5.835 0-7.614 12.249-8.014 22.692-18.559 30.593-30.887 1.777-2.772 5.889-2.772 7.666 0 7.901 12.328 18.346 22.874 30.594 30.887 2.719 1.778 2.719 5.834 0 7.613z",
    fill: "url(#SVGID_34_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m117.307 477.033c-12.248 8.014-22.693 18.559-30.594 30.888-1.777 2.772-5.889 2.772-7.666 0-7.901-12.328-18.345-22.874-30.593-30.887-2.719-1.779-2.719-5.835 0-7.614 12.249-8.014 22.692-18.559 30.593-30.887 1.777-2.772 5.889-2.772 7.666 0 7.901 12.328 18.346 22.874 30.594 30.887 2.719 1.779 2.719 5.834 0 7.613z",
    fill: "url(#SVGID_35_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPresent);
export default __webpack_public_path__ + "static/media/icon-present.4ccfdb31a691859d49784b89392a6aa0.svg";
export { ForwardRef as ReactComponent };